import { useState, useEffect } from "react";
import { Route, Redirect, useLocation, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setOpenInvitationModal } from "../redux/actions/confirmInvitationActionCreators";

import AuthLayout from "../layouts/AuthLayout";

function AuthRoute({ component: Component, ...rest }) {
  const location = useLocation();
  const params = useParams();
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("user");
  let parsedUser = {};
  if (storedUser) {
    try {
      parsedUser = JSON.parse(storedUser);
    } catch (e) {
      parsedUser = {};
    }
  }

  const [redirectUrl, setRedirectUrl] = useState("");
  const defaultRedirect =
    parsedUser?.account_type === "enterprise"
      ? parsedUser?.role === "cytailor_admin"
        ? "/super_admin_management"
        : "/enterprise"
      : "/quizzes";

  useEffect(() => {
    const redirect = location.search.match(/redirect=(.+)/);
    if (redirect?.length) {
      if (redirect[1].includes("/confirm-invitation")) {
        const substringToRemove = "/confirm-invitation/";
        const resultString = redirect[1].replace(substringToRemove, "");
        dispatch(setOpenInvitationModal(resultString));
        setRedirectUrl("/quizzes");
      } else {
        setRedirectUrl(redirect[1]);
      }
    } else {
      if (storedUser) {
        setRedirectUrl(defaultRedirect);
      }
    }
  }, [location, storedUser, dispatch, defaultRedirect]);

  const { isAuth } = useSelector((state) => state.user);

  return (
    <Route
      {...rest}
      component={(props) =>
        isAuth && redirectUrl ? (
          <Redirect to={redirectUrl} />
        ) : (
          <AuthLayout>
            <Component {...props} />
          </AuthLayout>
        )
      }
    />
  );
}

export default AuthRoute;
